export function IntegrationsIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.16732 6.3335C6.70708 6.3335 6.33398 6.70659 6.33398 7.16683V11.5002C6.33398 11.7763 6.11013 12.0002 5.83398 12.0002C5.55784 12.0002 5.33398 11.7763 5.33398 11.5002V7.16683C5.33398 6.15431 6.1548 5.3335 7.16732 5.3335H11.5007C11.7768 5.3335 12.0007 5.55735 12.0007 5.8335C12.0007 6.10964 11.7768 6.3335 11.5007 6.3335H7.16732ZM18.5007 12.0002C18.7768 12.0002 19.0007 12.224 19.0007 12.5002V17.1668C19.0007 18.1794 18.1798 19.0002 17.1673 19.0002H12.5007C12.2245 19.0002 12.0007 18.7763 12.0007 18.5002C12.0007 18.224 12.2245 18.0002 12.5007 18.0002H17.1673C17.6276 18.0002 18.0007 17.6271 18.0007 17.1668V12.5002C18.0007 12.224 18.2245 12.0002 18.5007 12.0002Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.1676 3C13.5233 3 13.001 3.52233 13.001 4.16667V9.83333C13.001 10.4777 13.5233 11 14.1676 11H19.8327C20.477 11 20.9993 10.4777 20.9993 9.83333V4.16667C20.9993 3.52233 20.477 3 19.8327 3H14.1676ZM14.001 4.16667C14.001 4.07462 14.0756 4 14.1676 4H19.8327C19.9247 4 19.9993 4.07462 19.9993 4.16667V9.83333C19.9993 9.92538 19.9247 10 19.8327 10H14.1676C14.0756 10 14.001 9.92538 14.001 9.83333V4.16667Z"
        fill="#FF6F26"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.16764 13C3.52331 13 3.00098 13.5223 3.00098 14.1667V19.8333C3.00098 20.4777 3.52331 21 4.16764 21H9.83268C10.477 21 10.9993 20.4777 10.9993 19.8333V14.1667C10.9993 13.5223 10.477 13 9.83268 13H4.16764ZM4.00098 14.1667C4.00098 14.0746 4.0756 14 4.16764 14H9.83268C9.92473 14 9.99935 14.0746 9.99935 14.1667V19.8333C9.99935 19.9254 9.92473 20 9.83268 20H4.16764C4.0756 20 4.00098 19.9254 4.00098 19.8333V14.1667Z"
        fill="#FF6F26"
      />
    </svg>
  );
}
